import { NavBar } from 'components/NavBar/NavBar';
import { Button, Flex, MainHeadline, PageWrapper, Table, Th, Tr } from 'styling/GlobalStyles';
import { BodyText } from 'styling/Typography';
import { useEffect, useState } from 'react';
import { AppDispatch, RootState } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination } from 'components/Pagination/Pagination';
import { handlePagination } from 'utils/helpers';
import { Td } from 'components/Td/Td';
import { Options } from 'components/Options/Options';
import { setConfirmModal } from 'features/global/globalSlice';
import { ModalTypes } from 'types/global.interface';
import { NoItems } from 'components/NoItems-fallback/NoItems';
import { FoodTableContainer } from 'pages/Food/Food.styled';
import { clearTransportation, deleteTransferZone, deleteTransportationVehicle, getTransferZones, getTransportationVehicles } from 'features/transportation/transportationSlice';
import { ITransportationVehicleModal, TransportationVehicleModal } from './TransportationVehicleModal';
import { ITransportationVehicleSingleResponse } from 'types/api/transportationApi.interface';
import { TransferZonesModal } from './TransferZonesModal';
import { transportationVehicleTypes } from './transportationData';
import { useNavigate } from 'react-router-dom';

export const Transportation = () => {
    const [vehiclesParams, setVehicleParams] = useState({ page: 1, limit: 5 })
    const [pointsParams, setPointsParams] = useState({ page: 1, limit: 5 })
    const { transferZones, vehicles } = useSelector((state: RootState) => state.transportation)
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const [vehiclesModal, setVehiclesModal] = useState({ open: false, value: null })
    const [pointsModal, setPointsModal] = useState({ open: false, value: null })

    useEffect(() => {
        dispatch(getTransportationVehicles(vehiclesParams))
    }, [vehiclesParams])

    useEffect(() => {
        dispatch(getTransferZones(pointsParams))
    }, [pointsParams])

    useEffect(() => {
        return (() => {
            dispatch(clearTransportation())
        })
    }, [])

    const handleDelete = (id: number, fn: any, setParams: any, noItems: boolean, word: string) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(fn(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems,
                },
                word: 'delete ' + word,
            }),
        )
    }

    const handleDeleteVehicle = (id: number) => handleDelete(id, deleteTransportationVehicle, setVehicleParams, vehicles.vehicles.length === 1, 'vehicle')
    const handleDeletePoint = (id: number) => handleDelete(id, deleteTransferZone, setPointsParams, transferZones.points.length === 1, 'transfer zone')


    const getVehicleModalValues = (item: ITransportationVehicleSingleResponse): ITransportationVehicleModal => {
        return {
            id: item.id,
            machine: { value: item.machine.id, label: item.machine.name },
            vehicleType: transportationVehicleTypes.find(t => t.value == item.vehicleType),
        }
    }

    return <>
        <NavBar />
        <PageWrapper noFooter >
            <Flex mb='16' between center>
                <MainHeadline>Transportation</MainHeadline>
                <Flex gap='1rem' >
                    <Button orange onClick={() => navigate('employees')}>Employees</Button>
                    <Button orange onClick={() => navigate('daily-intents')}>Daily Intents</Button>
                </Flex>
            </Flex>
            <Flex gap='1rem' height='90%' >
                <FoodTableContainer >
                    <Flex width='100%' between center >
                        <BodyText weight='bold' >VEHICLES</BodyText>
                        <Button orange onClick={() => setVehiclesModal({ open: true, value: null })} >Add</Button>
                    </Flex>
                    <Flex style={{ height: 'calc(100% - 40px)' }} between column>

                        {vehicles.noVehicles ? <NoItems title='Vehicles' /> : <Table>
                            <Th minWidth={0}>
                                <Td w='30%' noTooltip text='NAME' />
                                <Td w='65%' noTooltip text='TYPE' />
                                <Td w='5%' />
                            </Th>
                            {vehicles.vehicles.map((item) => {
                                return (
                                    <Tr small minWidth={0} key={item.id}>
                                        <Td w='30%' text={item?.machine?.name} />
                                        <Td w='65%' text={transportationVehicleTypes.find(t => t.value == item?.vehicleType)?.label || '/'} />
                                        <Td options w='5%'>
                                            <Options
                                                item={item}
                                                title='Transportation Vehicle'
                                                openModal={() => setVehiclesModal({ open: true, value: getVehicleModalValues(item) })}
                                                handleRemove={() => handleDeleteVehicle(item.id)}
                                            />
                                        </Td>

                                    </Tr>
                                )
                            })}
                        </Table>}
                        <Flex width='100%' justcenter >
                            <Pagination
                                setPage={(page) => handlePagination(page, setVehicleParams, 5)}
                                pageCount={Math.ceil(vehicles.totalPages)}
                                forcePage={(vehiclesParams.page ? vehiclesParams.page : 1) - 1}
                            />
                        </Flex>

                    </Flex>
                </FoodTableContainer>
                <FoodTableContainer>
                    <Flex width='100%' between center >
                        <BodyText weight='bold' >TRANSFER ZONES</BodyText>
                        <Button orange onClick={() => setPointsModal({ open: true, value: null })}>Add</Button>
                    </Flex>
                    <Flex style={{ height: 'calc(100% - 40px)' }} between column>

                        {transferZones.noPoints ? <NoItems title='Transfer Zones' /> : <Table>
                            <Th minWidth={0}>
                                <Td w='30%' noTooltip text='NAME' />
                                <Td w='65%' noTooltip text='ADDRESS' />
                                <Td w='5%' />
                            </Th>
                            {transferZones.points.map((item) => {
                                return (
                                    <Tr small minWidth={0} key={item.id}>
                                        <Td w='30%' text={item?.name} />
                                        <Td w='65%' text={item?.address} />
                                        <Td options w='5%' >
                                            <Options
                                                item={item}
                                                title='Transfer Point'
                                                openModal={() => setPointsModal({ open: true, value: item })}
                                                handleRemove={() => handleDeletePoint(item.id)}
                                            />
                                        </Td>

                                    </Tr>
                                )
                            })}
                        </Table>}



                        <Flex width='100%' justcenter >
                            <Pagination
                                setPage={(page) => handlePagination(page, setPointsParams, 5)}
                                pageCount={Math.ceil(transferZones.totalPages)}
                                forcePage={(pointsParams.page ? pointsParams.page : 1) - 1}
                            />
                        </Flex>
                    </Flex>
                </FoodTableContainer>
            </Flex>
            {vehiclesModal.open && <TransportationVehicleModal value={vehiclesModal.value} closeModal={() => setVehiclesModal({ value: null, open: false })} />}
            {pointsModal.open && <TransferZonesModal value={pointsModal.value} closeModal={() => setPointsModal({ value: null, open: false })} />}
        </PageWrapper>
    </>
}